/** 事前連絡・訪問の実施予定（Firestore / Project と同一値） */
export type PriorContactVisitPlan = 'will_do' | 'will_not_do' | 'undecided'

export const PRIOR_CONTACT_VISIT_PLAN_OPTIONS: ReadonlyArray<{
  value: PriorContactVisitPlan
  label: string
}> = [
  { value: 'will_do', label: '実施する' },
  { value: 'will_not_do', label: '実施しない' },
  { value: 'undecided', label: '未定' },
]

export function isPriorContactVisitPlan(v: string | null | undefined): v is PriorContactVisitPlan {
  return v === 'will_do' || v === 'will_not_do' || v === 'undecided'
}

export function priorContactVisitPlanLabel(v: string | null | undefined): string {
  if (!v) return ''
  const opt = PRIOR_CONTACT_VISIT_PLAN_OPTIONS.find((o) => o.value === v)
  return opt?.label ?? v
}
